import React, { Component } from 'react';
import { Container, Typography } from '@material-ui/core';
export class AdvertisementErrorBoundry extends Component {
	constructor() {
		super();

		this.state = {
			hasError: false,
		};
	}
	static getDerivedStateFromError(error) {
		return {
			hasError: true,
		};
	}
	componentDidCatch(error, info) {
		console.error('Advertisement Page ', error);
		console.error('More Info:', info);
	}
	render() {
		if (this.state.hasError) {
			return (
				<Container fixed>
					<Typography
						variant="h2"
						align="center"
						style={{
							backgroundColor: '#80acf2',
							color: '#ffffff',
							height: '50vh',
						}}>
						{' '}
						Something wrong happened!{' '}
					</Typography>
				</Container>
			);
		}
		return this.props.children;
	}
}

export default AdvertisementErrorBoundry;
